// komponent wise-avatar - avatar użytkownika z opcjonalnymi szczegółami

import React, { FC } from 'react';
import { Avatar, IconButton, Paper } from '@mui/material';
import { X } from 'react-bootstrap-icons';
import classnames from 'classnames';

import { useSelector } from 'store';
import { IUserProfile } from 'api/types';

import styles from 'theme/components/wise/WiseAvatar/WiseAvatar.module.scss';

interface IWiseAvatarProps {
  withDetails?: boolean;
  small?: boolean;
  fullWidth?: boolean;
  className?: string;
  onClick?: () => void;
  onCancel?: () => void;
  userData?: Pick<IUserProfile, 'first_name' | 'last_name' | 'email'> | null;
}

const WiseAvatar: FC<IWiseAvatarProps> = ({
  withDetails = false,
  small = false,
  fullWidth = false,
  className,
  onClick,
  onCancel,
  userData
}) => {
  const { profile } = useSelector((state) => state.auth);
  const data = userData ?? profile;

  if (!data) {
    return null;
  }

  const getInitials = () => {
    const firstName = data.first_name?.[0] || '';
    const lastName = data.last_name?.[0] || '';
    return `${firstName}${lastName}`.toUpperCase();
  };

  if (withDetails) {
    return (
      <div
        className={classnames(styles.componentWrapper, {
          [styles.small]: small,
          [styles.fullWidth]: fullWidth
        })}>
        <Paper
          className={classnames(styles.userCard, className, { [styles.clickable]: onClick })}
          elevation={0}
          onClick={onClick}
          style={onClick ? { cursor: 'pointer' } : undefined}>
          <Avatar className={styles.avatar}>{getInitials()}</Avatar>
          <div className={styles.userInfoRow}>
            <div className={styles.userInfo}>
              <div className={styles.userName}>
                {data.first_name} {data.last_name}
              </div>
              <div className={styles.userEmail}>{data.email}</div>
            </div>
            {onCancel && (
              <IconButton
                className={styles.cancelButton}
                onClick={(e) => {
                  e.stopPropagation();
                  onCancel();
                }}
                size="medium"
                aria-label="Anuluj">
                <X size={24} />
              </IconButton>
            )}
          </div>
        </Paper>
      </div>
    );
  }

  return (
    <div className={classnames(styles.componentWrapper, className, { [styles.small]: small })}>
      <Avatar
        className={classnames(styles.avatar, { [styles.clickable]: onClick })}
        onClick={onClick}
        style={onClick ? { cursor: 'pointer' } : undefined}>
        {getInitials()}
      </Avatar>
    </div>
  );
};

export default WiseAvatar;
